import React, { useState } from "react";
import Mobile from "../../component/mobile/mobile";
import "./Contact.css";
import { Contactus } from "../../env/action";

// Import icons from react-icons
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";

export default function Contact() {
  const [namee, setNamee] = useState("");
  const [email, setEmail] = useState("");
  const [inquiryType, setType] = useState("");
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent form reload
    setLoading(true);
    setResponseMsg("");

    const params = {
      name: namee,
      email: email,
      inquiry_type: inquiryType,
      message: message,
    };

    Contactus(params, (res) => {
      setLoading(false);

      if (res?.status === 1) {
        setResponseMsg("✅ " + res.message);
        setNamee("");
        setEmail("");
        setType("");
        setMessage("");
      } else {
        setResponseMsg("❌ Failed to send message. Please try again.");
      }
    });
  };

  return (
    <div className="contact-container">
      {/* Banner Section */}
      <div className="contact-banner">
        <h1 className="banner-title">Contact Us</h1>
      </div>

      {/* Contact Cards */}
      <div className="contact-cards">
        <div className="contact-card">
          <div className="icon-circle">
            <FaPhoneAlt />
          </div>
          <h3>Call Us</h3>
          <p>
            <a href="tel:+911234567890">+91 9861806040</a>
          </p>
        </div>

        <div className="contact-card">
          <div className="icon-circle">
            <FaMapMarkerAlt />
          </div>
          <h3>Location</h3>
          <p>
            OCAC Tower, Acharya Vihar,
            <br />
            Bhubaneswar, Odisha - 751013
          </p>
        </div>

        <div className="contact-card">
          <div className="icon-circle">
            <FaEnvelope />
          </div>
          <h3>Email</h3>
          <p>
            <a href="mailto:support@techtricks.in">support@techtricks.in</a>
          </p>
        </div>
      </div>

      {/* Form + Map Section */}
      <div className="contact-main">
        <div className="contact-form-section">
          <h2 className="contact-title">Get in Touch</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={namee}
                onChange={(e) => setNamee(e.target.value)}
                placeholder="Enter your full name"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="inquiryType">Type of Request</label>
              <select
                id="inquiryType"
                name="inquiryType"
                value={inquiryType}
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="">-- Select one --</option>
                <option value="general-inquiry">General Inquiry</option>
                <option value="service-related">Service/Support Related</option>
                <option value="feedback">Feedback</option>
                <option value="data-removal">Remove My Data</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Write your message here"
                required
              />
            </div>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Sending…" : "Send Message"}
            </button>

            {responseMsg && <p className="form-response">{responseMsg}</p>}
          </form>
        </div>

        <div className="contact-map">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29930.26716944765!2d85.79361990940006!3d20.329907986085225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190910433a10a7%3A0xd4c260c770582e18!2sChandrasekharpur%2C%20Bhubaneswar%2C%20Odisha!5e0!3m2!1sen!2sin!4v1751620933475!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
